(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/overrides/sport/trotting.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/overrides/sport/trotting.js');
"use strict";


const _svs$components$sport = svs.components.sportinfo.common,
  MatchState = _svs$components$sport.matchState.SportinfoMatchState,
  _svs$components$sport2 = _svs$components$sport.constants,
  SportinfoPathNames = _svs$components$sport2.SportinfoPathNames,
  ContentProvider = _svs$components$sport2.ContentProvider,
  SvsViewType = _svs$components$sport2.SvsViewType;
const ConfigBuilder = svs.components.sportinfo.configBuilder.ConfigBuilder;
const _ConfigBuilder$addTab = new ConfigBuilder().addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }, {
    label: 'Startfält'
  }).addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]);
  }, {
    label: 'Loppinfo'
  }).setDefaultRoutes(SportinfoPathNames.News, [MatchState.NotStarted, MatchState.Ongoing, MatchState.Finished]).build(),
  content = _ConfigBuilder$addTab.content,
  menuItems = _ConfigBuilder$addTab.menuItems,
  defaultRoutes = _ConfigBuilder$addTab.defaultRoutes;
setGlobal('svs.components.sportinfo.configs.sportConfigs.sportTypeOverrides', {
  trottingConfig: {
    menuItems,
    content,
    defaultRoutes,
    config: 'trotting' 
  }
});

 })(window);